export default function(map) {
  var entries = [];
  for (var key in map) entries.push({key: key, value: map[key]});
  return entries;
}



//////////////////
// WEBPACK FOOTER
// /home/circleci/pickle/~/d3-collection/src/entries.js
// module id = c8dA
// module chunks = 0